import type { ConversationType, ItemRow, Maybe } from 'owa-graph-schema';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import type { MailListRowDataType } from 'owa-mail-list-store';

/**
 * Get the date sort time stamp from server row data
 * @param row the row data
 * @param listViewType of the table
 * @returns the lastDeliveryOrRenewTimeStamp and lastDeliveryTimeStamp of the row data
 */
export default function getDateSortTimeStampFromRowData(
    row: MailListRowDataType,
    listViewType: ReactListViewType
): {
    lastDeliveryOrRenewTimeStamp: Maybe<string> | undefined;
    lastDeliveryTimeStamp: Maybe<string> | undefined;
    lastModifiedTime: Maybe<string> | undefined;
} {
    let lastDeliveryOrRenewTimeStamp;
    let lastDeliveryTimeStamp;
    let lastModifiedTime;
    switch (listViewType) {
        case 0:
            lastDeliveryOrRenewTimeStamp = (row as ConversationType).LastDeliveryOrRenewTime;
            lastDeliveryTimeStamp = (row as ConversationType).LastDeliveryTime;
            lastModifiedTime = (row as ConversationType).LastModifiedTime;
            break;

        case 1:
            lastDeliveryOrRenewTimeStamp = (row as ItemRow).ReceivedOrRenewTime;
            lastDeliveryTimeStamp = (row as ItemRow).DateTimeReceived;
            lastModifiedTime = (row as ItemRow).LastModifiedTime;
            break;
    }

    return { lastDeliveryOrRenewTimeStamp, lastDeliveryTimeStamp, lastModifiedTime };
}
